module.exports = __webpack_public_path__ + "img/twitter.b9d40eaa.svg";